"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirtablePage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const layout_1 = require("@/common/components/layout");
const StyledIframe = styled_components_1.default.iframe `
  background: transparent;
  border: 1px solid #ccc;
  width: 100%;
  height: calc(100vh - 192px);
`;
const AirtablePage = ({ title, src, description }) => (react_1.default.createElement(layout_1.PolarisPage, { fullWidth: true, hasSubtitleMaxWidth: true, subtitle: description, title: title },
    react_1.default.createElement(StyledIframe, { frameBorder: '0', src: src })));
exports.AirtablePage = AirtablePage;
